export enum SequenceMode {
    Default,
    Playback,
    Timeline,
}
